<template>
<v-card>
	<v-list>
		<!--v-list-tile>
			<v-btn block small flat to="/users">{{translater.__('Users', 'users')}}</v-btn>
		</v-list-tile-->
		<v-list-tile>
			<v-btn block small flat to="/routes">{{translater.__('Routes', 'routes')}}</v-btn>
		</v-list-tile>
		<v-list-tile>
			<v-btn block small flat to="/account">{{translater.__('Account', 'users')}}</v-btn>
		</v-list-tile>
		<v-list-tile>
			<v-btn block small flat to="/logout">{{translater.__('Logout', 'users')}}</v-btn>
		</v-list-tile>
	</v-list>
</v-card>
</template>

<script>
	export default {
		name: 'AdminMedium',

		computed: {
			translater: {
				get()
				{
					let t = this.$store.getters['translate/translater']
					
					return t;
				}
			}
		}
	}
</script>


